
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A4A4A4","d":"M14.76.24a.539.539 0 00-.738 0L7.5 6.76.978.24a.539.539 0 00-.739 0 .539.539 0 000 .738L6.761 7.5.239 14.022a.539.539 0 000 .739.51.51 0 00.37.152.51.51 0 00.37-.152L7.5 8.239l6.522 6.522a.51.51 0 00.37.152.51.51 0 00.369-.152.539.539 0 000-.74L8.239 7.5 14.761.978a.539.539 0 000-.739z"}})])
          )
        }
      }
    